import React from 'react';
import Loader from 'react-loader-spinner';

function LoadingSpinner() {
    return (
         <div className="body">
                    <div className="breakpointContainer">
                        <div className="loadingDiv">
                            <Loader
                                type="TailSpin"
                                color="#fe5b5d"
                                height={120}
                                width={120}              
                            //  timeout={3000} //3 secs
                            />
                            </div>
                    </div>
                </div>
    )
}

export default LoadingSpinner;